export let customSettings = {
  captchaOn: false,
  toastPosition: "top-right",
  toastClose: 2000,
};

export const BASEURL =
  window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_URL;
